import React, { useMemo } from 'react';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import { useParams } from 'react-router-dom';
import InitiateRFQContent from 'components/rfq/initiate-rfq/rfq-initiation';
import RFQInitiationPageStore, { PageStoreContext } from 'store/pages/rfq/initiate-rfq/rfq-initiation/pageStore';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';
import { RFQ_PROPOSAL_CARD_DATA } from 'global/checklists-helpers/RFQProposalChecklistHelper';
import RFQChecklistOptionHeader from 'components/common/headers/RFQChecklistOptionHeader';

const InitiateRFQPage = (): JSX.Element => {
  const query = useQueryParams();
  const { periodId } = useParams<{ periodId: string }>();
  const cartId = query.get('cartId') || '';

  if (!periodId || !cartId) {
    throw new Error(`InitiateRFQPage: missing URL params. periodId=${periodId}, cartId=${cartId}`);
  }
  const pageStore = useMemo(() => new RFQInitiationPageStore({ periodId, cartId }), [periodId, cartId]);

  return (
    <RFQStatusLayout>
      <PageStoreContext.Provider value={pageStore}>
        <RFQChecklistOptionHeader
          title={RFQ_PROPOSAL_CARD_DATA.INITIATE_RFQ.title}
          subtitle={RFQ_PROPOSAL_CARD_DATA.INITIATE_RFQ.text}
          onRedirectBack={pageStore.redirectToChecklist}
        />
        <InitiateRFQContent />
      </PageStoreContext.Provider>
    </RFQStatusLayout>
  );
};

export default InitiateRFQPage;
